import clsx from "clsx";
import React from "react";

import styles from "./index.module.css";

export interface ElevatedBoxProps {
  /** Padding options */
  padding?: "base" | "sm" | "none";
  /** Max-width */
  maxWidth?: boolean;
  /** Additional class names */
  className?: string;
}

/**
 * A box with a shadow used for `Popover` and `ButtonDropdown`.
 */

const ElevatedBox: React.FC<React.PropsWithChildren<ElevatedBoxProps>> = ({
  padding = "base",
  children,
  className,
  ...rest
}) => {
  const classes = clsx(styles.root, styles[`padding-${padding}`], className);

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default ElevatedBox;
